/**
 * Момент события смены этапа (`project_status_events.occurred_at`) из дня и времени, набранных по местному времени, —
 * общий для окна дат старой таблицы (DateLogCell) и строк дат блока «Этапы».
 */

export interface StatusEventTime {
  h: number;
  m: number;
  s: number;
}

const MIDNIGHT: StatusEventTime = { h: 0, m: 0, s: 0 };

/** чч:мм:сс или чч:мм (секунды = 0). Пусто — полночь. Не время или вне суток — null. */
export function parseStatusEventTime(timeStr: string): StatusEventTime | null {
  const t = timeStr.trim();
  if (!t) return MIDNIGHT;
  const match = t.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
  if (!match) return null;
  const h = Number(match[1]);
  const m = Number(match[2]);
  const s = match[3] === undefined ? 0 : Number(match[3]);
  if (h > 23 || m > 59 || s > 59) return null;
  return { h, m, s };
}

/** День (берётся только календарный день) и время по местному времени → ISO строка момента */
export function statusEventOccurredAtIso(day: Date, time: StatusEventTime): string {
  const combined = new Date(day);
  combined.setHours(time.h, time.m, time.s, 0);
  return combined.toISOString();
}
